import { useCallback, useLayoutEffect, useState } from 'react'

import { t } from 'i18next'

import { getVideoDimensions } from '~/helpers'
import { isPublisher, isReadOnly } from '~/helpers/token-info'

import ReviewActions from './ReviewActions'

const ItemVideo: ReviewRowComponent = data => {
  const [dimensions, setDimensions] = useState<VideoProps>()

  const getDimensions = useCallback(async () => {
    const imageDimensions = await getVideoDimensions(data.settings.media_url)

    setDimensions(imageDimensions)
  }, [data.settings.media_url])

  useLayoutEffect(() => {
    getDimensions()
  }, [getDimensions])

  return (
    <section className="d-flex align-items-center">
      <div className="mainInfo d-flex flex-column gap-1">
        <div className="adSize w-100">
          <strong>Tamanho da mídia:</strong> {data.settings.ad_size}
          <small>
            ({dimensions?.width}px x {dimensions?.height}px)
          </small>
        </div>

        {dimensions?.duration && (
          <div className="duration">
            <span className="duration">
              {t('rm:campaign.create.FileToUpload.duration')}:{' '}
              {t('c:words.secondCount', {
                count: Math.floor(dimensions.duration)
              })}
            </span>
          </div>
        )}

        {data.status === 'pending_review' && isPublisher() && !isReadOnly() && (
          <ReviewActions adId={data.id} />
        )}
      </div>
    </section>
  )
}

export default ItemVideo
